function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "23",
  height: "23"
}, props), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("circle", {
  cx: "11.4",
  cy: "11.4",
  r: "11.4",
  fill: "#383CBC"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M9.994 15.543a.793.793 0 010-1.004l2.736-3.18-2.736-3.183a.793.793 0 01.015-.986.55.55 0 01.848-.018l3.167 3.684a.804.804 0 010 1.003l-3.167 3.684a.552.552 0 01-.863 0z"
})));